import * as yup from 'yup';

const DEFAULT_REQUIRED_MESSAGE = 'required';

export const VALIDATION_SCHEMA = yup.object().shape({
  author: yup.string().required(DEFAULT_REQUIRED_MESSAGE),
  email: yup.string().email('email'),
  phoneNumber: yup.string(),
  manager: yup.number().required(DEFAULT_REQUIRED_MESSAGE),
  date: yup.string().required(DEFAULT_REQUIRED_MESSAGE),
  department: yup.string().required(DEFAULT_REQUIRED_MESSAGE),
  description: yup.string().nullable().required(DEFAULT_REQUIRED_MESSAGE),
  currentSituationDescription: yup.string().required(DEFAULT_REQUIRED_MESSAGE),
  futureSituationDescription: yup.string().required(DEFAULT_REQUIRED_MESSAGE),
  mainProblemFix: yup.string().required(DEFAULT_REQUIRED_MESSAGE),
  standardization: yup.string().required(DEFAULT_REQUIRED_MESSAGE),
});
